import { IDispatchId, IRequestError } from '../../utils/helpers/redux.helper';
import { Account } from './account.model';
import { User } from './user.model';

// action enums
export enum ActionsEnum {
  FETCH_ACCOUNT_DETAILS = 'FETCH_ACCOUNT_DETAILS',
  FETCH_ACCOUNT_DETAILS_SUCCESS = 'FETCH_ACCOUNT_DETAILS_SUCCESS',
  FETCH_ACCOUNT_DETAILS_ERROR = 'FETCH_ACCOUNT_DETAILS_ERROR',
  UPDATE_ACCOUNT = 'UPDATE_ACCOUNT',
  UPDATE_USER = 'UPDATE_USER',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  CHANGE_EMAIL_SUCCESS = 'CHANGE_EMAIL_SUCCESS',
  CHANGE_EMAIL_ERROR = 'CHANGE_EMAIL_ERROR',
}

// action payload interfaces
export interface IUpdateAccountPayload {
  account: Account;
}

export interface IUpdateUserPayload {
  user: User;
}

export interface IChangeEmail extends IDispatchId {
  emailAddress: string;
  locale: string;
}

// action definitions
export interface FetchAccountDetails {
  type: ActionsEnum.FETCH_ACCOUNT_DETAILS;
  payload: IDispatchId;
}

export interface FetchAccountDetailsSuccess {
  type: ActionsEnum.FETCH_ACCOUNT_DETAILS_SUCCESS;
  payload: IDispatchId;
}

export interface FetchAccountDetailsError {
  type: ActionsEnum.FETCH_ACCOUNT_DETAILS_ERROR;
  payload: IRequestError;
}

export interface UpdateAccount {
  type: ActionsEnum.UPDATE_ACCOUNT;
  payload: IUpdateAccountPayload;
}

export interface UpdateUser {
  type: ActionsEnum.UPDATE_USER;
  payload: IUpdateUserPayload;
}

export interface ChangeEmail {
  type: ActionsEnum.CHANGE_EMAIL;
  payload: IChangeEmail;
}

export interface ChangeEmailSuccess {
  type: ActionsEnum.CHANGE_EMAIL_SUCCESS;
  payload: IDispatchId;
}

export interface ChangeEmailError {
  type: ActionsEnum.CHANGE_EMAIL_ERROR;
  payload: IRequestError;
}

// action creators
export const fetchAccountDetails = (
  dispatchId: string
): FetchAccountDetails => ({
  type: ActionsEnum.FETCH_ACCOUNT_DETAILS,
  payload: {
    dispatchId,
  },
});

export const fetchAccountDetailsSuccess = (
  dispatchId: string
): FetchAccountDetailsSuccess => ({
  type: ActionsEnum.FETCH_ACCOUNT_DETAILS_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const fetchAccountDetailsError = (
  dispatchId: string,
  error: Error
): FetchAccountDetailsError => ({
  type: ActionsEnum.FETCH_ACCOUNT_DETAILS_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const updateAccount = (account: Account): UpdateAccount => ({
  type: ActionsEnum.UPDATE_ACCOUNT,
  payload: {
    account,
  },
});

export const updateUser = (user: User): UpdateUser => ({
  type: ActionsEnum.UPDATE_USER,
  payload: {
    user,
  },
});

export const changeEmail = (
  dispatchId: string,
  emailAddress: string,
  locale: string
): ChangeEmail => ({
  type: ActionsEnum.CHANGE_EMAIL,
  payload: {
    dispatchId,
    emailAddress,
    locale,
  },
});

export const changeEmailSuccess = (dispatchId: string): ChangeEmailSuccess => ({
  type: ActionsEnum.CHANGE_EMAIL_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const changeEmailError = (
  dispatchId: string,
  error: Error
): ChangeEmailError => ({
  type: ActionsEnum.CHANGE_EMAIL_ERROR,
  payload: {
    dispatchId,
    error,
  },
});
